let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class SalesHomeService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
  }
  
  getOrdersConsolidated(thirdId, startDate, endDate, branchCode, contactoId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.B2B.CONSOLIDATED+
        '?terceroId=' + thirdId +
        '&fechaInicial=' + startDate +
        '&fechaFinal=' + endDate +
        '&sucursalCodigo=' + branchCode +
        '&contactoId=' + contactoId,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getLastItemsBought(userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.PRODUCTS.LAST_ITEMS_BOUGHT +
        "?userId=" + userId +
        '&limit=5',
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getInfoBillfoldState(thirdDocumentNumber, branchCode) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.B2B.BILLFOLD_RESUME +
        '?terceroDocumentoNumero=' + thirdDocumentNumber +
        '&sucursalCodigo=' + branchCode,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }


}

SalesHomeService.$inject = inject;

export default SalesHomeService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/sales-home/sales-home.service.js
 **/